import {
  IHawkerSessionFormFieldPath,
  IHawkerSessionRightFormFieldPath,
} from '@app/shared/types/entities/hawker-session/hawker-session.types';

export const HAWKER_SESSION_FORM_FIELD_PATH: IHawkerSessionFormFieldPath = {
  employeeId: 'employee.id',
  eventName: 'event.name',
  eventId: 'event.id',
  commissionRateEntityId: 'commission_rate.entity_id',
  eventDate: 'virtual.event_date',
  status: 'status',
  siteId: 'site_id',
  siteName: 'site_name',
  storeNumber: 'store_number',
  products: 'products',
  virtualProducts: 'virtual.products',
  virtualInformationData: 'virtual.information_data',
};

export const HAWKER_SESSION_RIGHT_FORM_FIELD_PATH: IHawkerSessionRightFormFieldPath =
  {
    products: 'product_list',
  };

export const DEFAULT_INFORMATION_DATA = {
  terminal_sales: 0,
  taxes: 0,
  tips: 0,
  miscellaneous: 0,
  payments: {
    cash: 0,
    custom: 0,
    credit: 0,
    debit: 0,
    gift: 0,
  },
};
